export default __webpack_public_path__ + "envelop2.png?10adb3db7d97edd19a646258290f12cc";